"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconWifiConnected = function SvgIconWifiConnected(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "wifi connected icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Wifi Connected Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.998 33.415a2.856 2.856 0 110 5.705 2.856 2.856 0 010-5.709zm7.708-4.846a2.14 2.14 0 01-3.027 3.024 6.615 6.615 0 00-9.352 0 2.152 2.152 0 01-3.035 0 2.152 2.152 0 010-3.035 10.9 10.9 0 0115.415.011zm5.788-5.794a2.152 2.152 0 01-1.51 3.661 2.137 2.137 0 01-1.513-.63 14.825 14.825 0 00-20.943 0 2.152 2.152 0 01-3.035 0 2.152 2.152 0 010-3.031 19.106 19.106 0 0127 0zm-32.87-5.888c10.685-10.681 28.07-10.681 38.758 0a2.152 2.152 0 01-1.514 3.662 2.137 2.137 0 01-1.51-.631 23.142 23.142 0 00-32.702 0 2.152 2.152 0 01-3.032 0 2.152 2.152 0 010-3.031z"
  }));
};

var _default = SvgIconWifiConnected;
exports.default = _default;